import React from 'react'
import { Button } from '~/components/common/Button'
import { Typography } from '~/components/common/Typography'
import { ChevronLeftIcon, ChevronRightIcon } from '~/components/usage-dashboard/icons'

export interface PaginationProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  className?: string
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  className = ''
}) => {
  const handlePrevious = () => {
    onPageChange(Math.max(1, currentPage - 1))
  }

  const handleNext = () => {
    onPageChange(Math.min(totalPages, currentPage + 1))
  }

  return (
    <div className={`flex items-center justify-center gap-2 h-10 ${className}`}>
      <Button
        variant='borderless'
        onClick={handlePrevious}
        disabled={currentPage === 1}
        className='p-0 w-6 h-6 rounded flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-transparent disabled:opacity-30 disabled:cursor-not-allowed transition-colors'
      >
        <ChevronLeftIcon />
      </Button>
      <div className='flex items-center gap-0'>
        <div className='w-6 h-6 flex items-center justify-center'>
          <Typography fontFamily='geistMono' fontSize='labelSm' className='text-gray-500'>
            {currentPage}
          </Typography>
        </div>
        <div className='w-6 h-6 flex items-center justify-center'>
          <Typography fontFamily='geistMono' fontSize='labelSm' className='text-gray-500'>
            /
          </Typography>
        </div>
        <div className='w-6 h-6 flex items-center justify-center'>
          <Typography fontFamily='geistMono' fontSize='labelSm' className='text-gray-500'>
            {totalPages}
          </Typography>
        </div>
      </div>
      <Button
        variant='borderless'
        onClick={handleNext}
        disabled={currentPage === totalPages}
        className='p-0 w-6 h-6 rounded flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-transparent disabled:opacity-30 disabled:cursor-not-allowed transition-colors'
      >
        <ChevronRightIcon />
      </Button>
    </div>
  )
}
